import { render } from "./ServicesDetailsPage.vue?vue&type=template&id=b4200e18"
import script from "./ServicesDetailsPage.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__